/**
 * package: com.inq.flash.client.control
 * class: ClientConnectionEventHandler
 * root Object
 * @constructor
 */
com.inq.flash.client.control.ClientConnectionEventHandler = function(controller) {
	this.controller = controller;
};
$hxClasses['com.inq.flash.client.control.ClientConnectionEventHandler'] = com.inq.flash.client.control.ClientConnectionEventHandler;
/** @private @type {Array} */
com.inq.flash.client.control.ClientConnectionEventHandler.__name__ = ["com","inq","flash","client","control","ClientConnectionEventHandler"];

/**
 * allConnectionAttemptsFailed
 *
 * $type TFun([],TEnum(Void,[]))
 * public function allConnectionAttemptsFailed():Void
 * @public
 * @this com.inq.flash.client.control.ClientConnectionEventHandler
 * @return {void}
 */
com.inq.flash.client.control.ClientConnectionEventHandler.prototype.allConnectionAttemptsFailed = function() {
};


/**
 * connectionSuccessful
 *
 * $type TFun([],TEnum(Void,[]))
 * public function connectionSuccessful():Void
 * @public
 * @this com.inq.flash.client.control.ClientConnectionEventHandler
 * @return {void}
 */
com.inq.flash.client.control.ClientConnectionEventHandler.prototype.connectionSuccessful = function() {
	haxe.Log.trace("enter",{ fileName : "ClientConnectionEventHandler.hx", lineNumber : 25, className : "com.inq.flash.client.control.ClientConnectionEventHandler", methodName : "connectionSuccessful"});
	this.controller.connectionEstablished();
	haxe.Log.trace("exit",{ fileName : "ClientConnectionEventHandler.hx", lineNumber : 27, className : "com.inq.flash.client.control.ClientConnectionEventHandler", methodName : "connectionSuccessful"});
};


/**
 * connectionClosedNeedRetryRequest
 *
 * $type TFun([],TEnum(Bool,[]))
 * public function connectionClosedNeedRetryRequest():Bool
 * @public
 * @this com.inq.flash.client.control.ClientConnectionEventHandler
 * @return {boolean}
 */
com.inq.flash.client.control.ClientConnectionEventHandler.prototype.connectionClosedNeedRetryRequest = function() {
	return this.connectionFailedNeedRetryRequest(3,3);
};


/**
 * connectionFailedNeedRetryRequest
 *
 * $type TFun([{ name => connectionRetryAttempts, t => TInst(Int,[]), opt => false },{ name => maxConnectionRetries, t => TInst(Int,[]), opt => false }],TEnum(Bool,[]))
 * public function connectionFailedNeedRetryRequest(connectionRetryAttempts:Int, maxConnectionRetries:Int):Bool
 * @public
 * @this com.inq.flash.client.control.ClientConnectionEventHandler
 * @param {number}  connectionRetryAttempts 
 * @param {number}  maxConnectionRetries 
 * @return {boolean}
 */
com.inq.flash.client.control.ClientConnectionEventHandler.prototype.connectionFailedNeedRetryRequest = function(connectionRetryAttempts,maxConnectionRetries) {
	this.controller.connectionLost();
	if(this.controller.shouldBeDisconnected()) return false;
	/* we have the option here to call on the controller or SkinControl so that the send button can be disabled */
	return true;
};

/** @private @type {com.inq.flash.client.control.ApplicationController} */
com.inq.flash.client.control.ClientConnectionEventHandler.prototype.controller = null;
/** @type {com.inq.flash.client.control.ClientConnectionEventHandler} */
com.inq.flash.client.control.ClientConnectionEventHandler.prototype.__class__ = com.inq.flash.client.control.ClientConnectionEventHandler;
